// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__8wTrf","child1":"style_child1__dJ7UO","child2":"style_child2__L+Xr3"};